import { writable } from "svelte/store"

const defaultData = {code: "000000"}

export const join = writable(defaultData)

let currentJoin = {}
join.subscribe( value => currentJoin = value )

const addDash = code => code.substr(0,3) + '-' + code.substr(3,3)
let lastCode = "000000"
join.subscribe(room => {
    if (room.code === lastCode) return;    
    lastCode = room.code
    const newCode = room.code === "000000" ? "" : addDash(room.code)
    history.pushState({}, `KVIZ.party - ${newCode}`, `/${newCode}`)
})

export const changeJoinState = (newState) => {
    join.set({
        ...currentJoin,
        state: newState
    })
}

export const restartDefault = () => {
    join.set(defaultData)
}